import { Injectable } from '@angular/core';
import { HttpClient } from '@elotech/angular-common';
import { Observable } from 'rxjs';

const RESOURCE = '/api/movimentacao-redutor-carga-horaria';

@Injectable()
export class MovimentacaoRedutorCargaHorariaService {

  constructor(private _httpClient: HttpClient) {
  }

  public salvar(body: any) {
    const requestParam = {
      resource: RESOURCE,
      body: body
    };
    return this._httpClient.post(requestParam);
  }

  public getPercentualReducao(funcionarioId: number): Observable<string> {
    return this._httpClient.get({
      disableSpinner: true,
      resource: `${RESOURCE}/get-percentual-reducao/${funcionarioId}`
    });
  }

}
